import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ColDef, ColGroupDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyService } from '../../../services';
import { GridComponent } from '../grid/grid.component';

@Component({
  selector: 'app-report-grid',
  templateUrl: './report-grid.component.html',
  styleUrl: './report-grid.component.scss',
})
export class ReportGridComponent implements OnInit {
  @Input() header: string;
  @Input() gridCssClass: string;
  @Input() columnDefs?: (ColDef | ColGroupDef)[] = [];
  @Input() rowData: any[];
  @Input() fields: FormlyFieldConfig[] = [];
  @Input() labelsVertical = false;

  gridOptions: GridOptions;
  model: any = { preview: false };

  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;

  constructor(private formlyService: FormlyService) {}

  ngOnInit() {
    this.fields.push(
      ...[
        this.formlyService.button('Print', () => this.print(), {
          iconClass: 'fa fa-print',
        }),
        this.formlyService.button(
          'Preview',
          () => this.togglePreview(),
          {
            btnClass: 'secondary',
          },
          undefined,
          {
            'props.iconClass': (field: FormlyFieldConfig) => (field.model?.preview ? 'fa fa-eye-slash' : 'fa fa-eye'),
          },
        ),
        this.formlyService.exportButtonNoGridComponent(() => this.export()),
      ],
    );

    this.gridOptions = {
      columnDefs: this.columnDefs,
      defaultColDef: {
        filter: true,
        resizable: true,
        sortable: true,
      },
    };
  }

  gridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  export() {
    this.gridApi.exportDataAsCsv({ fileName: this.header });
  }

  print() {
    window.print();
  }

  togglePreview() {
    this.model.preview = !this.model.preview;
  }

  rowDataUpdated() {
    this.gridColumnApi?.autoSizeAllColumns();
  }
}
